import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAuthToken } from '../../../utils/auth';
 
// Async Thunks
export const fetchAddresses = createAsyncThunk('customerAddresses/fetchAddresses', async () => {
   const token = getAuthToken();
    const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/customer/addresses',{
        headers: {
            'Content-Type':'application/json',
            'Authorization': `Bearer ${token}`,
          }, 
          method: 'GET',

    }); 
    return response.json(); 
});

export const createAddress = createAsyncThunk('customerAddresses/createAddress', async (newAddress: {}) => {
    const token = getAuthToken();
    const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/customer/addresses', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ address: newAddress })
      });
      return response.json(); 

});

export const updateAddress = createAsyncThunk('customerAddresses/updateAddress', async (newAddress: {}) => {
    const token = getAuthToken();
    const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/customer/addresses/'+newAddress["address_id"], {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ address: newAddress })
      });
      return response.json(); 

});
 
export const deleteAddress = createAsyncThunk('customerAddresses/deleteAddress', async (id:number) => {
    const token = getAuthToken();
    const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/customer/addresses/'+id, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      });
      return response.json(); 

});
 

const addressesSlice = createSlice({
    name: 'customerAddresses',
    initialState: {
        loading: false,
        addresses:   ([] as any[]),
        error: '',
        formErrors: [],
        formModalErrors: [],
        modalShow: false,
    },
    reducers: {
        openModal: state => {
            state.modalShow = true;
          },
          closeModal: state => {
            state.modalShow = false;
          }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAddresses.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAddresses.fulfilled, (state, action) => {
                state.loading = false;
                state.addresses = action.payload.data;
                state.error = '';
            })
            .addCase(fetchAddresses.rejected, (state, action) => {
                state.loading = false;
                state.addresses = [];
                state.error = action.error.message + "";

            }) 
            .addCase(createAddress.pending, (state) => {
                state.loading = true;
            })
            .addCase(createAddress.fulfilled, (state, action) => {
                if (action.payload.status === 'success'){
                    state.loading = false;
                    state.addresses = state.addresses.concat(action.payload.data);
                    state.error = '';
                    state.modalShow = false;
                    state.formModalErrors = []
                }
                else{
                    state.formModalErrors = action.payload.errors
                    state.error = '';

                }
            })
            .addCase(createAddress.rejected, (state, action) => {
                state.loading = false;
                state.addresses = [];
                state.error = action.error.message + "";

            }) 
            
            .addCase(updateAddress.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateAddress.fulfilled, (state, action) => {
                if (action.payload.status === 'success'){
                    state.loading = false;
                    //state.addresses = state.addresses.concat(action.payload.data);
                    const index = state.addresses.findIndex(address => address.id === action.payload.data.id);
                    state.addresses[index] = action.payload.data;
                    state.error = '';
                    state.modalShow = false;
                    state.formModalErrors = []
                }
                else{
                    state.formModalErrors = action.payload.errors
                    state.error = '';

                }
            })
            .addCase(updateAddress.rejected, (state, action) => {
                state.loading = false;
                state.addresses = [];
                state.error = action.error.message + "";

            }) 
            .addCase(deleteAddress.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteAddress.fulfilled, (state, action) => {
                if (action.payload.status === 'success'){
                    state.loading = false;
                    //state.addresses = state.addresses.concat(action.payload.data);
                    state.addresses = state.addresses.filter(address => address.id+'' !== action.payload.removed_id+'');

                    state.error = '';
                    state.modalShow = false;
                    state.formModalErrors = []
                }
                else{
                    state.formModalErrors = action.payload.errors
                    state.error = '';

                }
            })
            .addCase(deleteAddress.rejected, (state, action) => {
                state.loading = false;
                state.addresses = [];
                state.error = action.error.message + "";

            })
    }
});
export const { openModal, closeModal } = addressesSlice.actions;
export default addressesSlice.reducer;
